import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEdit,
  faEye,
  faPlus,
  faSearch,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast } from "react-hot-toast";
import moment from "moment";
import { generateConfirm } from "../../helpers";
import useScrollTop from "../../hooks/useScrollTop";
import { QuizListing, quizStatus } from "../../services/quiz";
import usePermissionStatus from "../../hooks/usePermissionStatus";

const QuizList = () => {
  const navigate = useNavigate();
  const [searchQuiz, setSearchQuiz] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const permit = usePermissionStatus(["add_quiz", "edit_quiz", "delete_quiz"]);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    search_key: "",
  });

  const [quizLists, setQuizLists] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const pageCount = Math.ceil(totalCount / payload.limit);
  useScrollTop();

  useEffect(() => {
    localStorage.removeItem("current_quiz_id");
    localStorage.removeItem("current_quiz_details");
    fetchQuizList();
  }, [payload]);

  const fetchQuizList = async () => {
    setIsLoading(true);
    try {
      const response = await QuizListing(payload);
      if (response?.data?.statusCode === 200) {
        setQuizLists(response?.data?.result);
        setTotalCount(response?.data?.total_count);
      } else {
        toast.error("Failed to fetch quizzes");
      }
    } catch (error) {
      toast.error("Error fetching quizzes");
    }
    setIsLoading(false);
  };

  const handlePageClick = (e) => {
    setPayload({ ...payload, page: e.selected + 1 });
  };

  const handleSearch = () => {
    setPayload({ ...payload, search_key: searchQuiz, page: 1 });
  };

  const updateQuizStatus = async (quizId, newStatus) => {
    try {
      const response = await quizStatus({
        quiz_id: String(quizId),
        status: newStatus,
      });

      if (response?.data?.statusCode === 200) {
        toast.success(
          response?.data?.statusMessage || "Status updated successfully"
        );
        fetchQuizList();
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      toast.error("Error updating status");
    }
  };

  const handleToggleStatus = (quizId, currentStatus) => {
    const newStatus = currentStatus === "1" ? "0" : "1";
    updateQuizStatus(quizId, newStatus);
  };

  const handleDeleteQuiz = (quizId) => {
    updateQuizStatus(quizId, "2");
  };

  return (
    <div className="dashboard quiz-list">
      <div className="subheader">
        <Row>
          <Col xs={5}>
            <h2 className="heading-36 ">Quiz List</h2>
          </Col>
          <Col xs={7}>
            <div className="subheader-right">
              <div className="subheader-right-top">
                <Form.Group controlId="formFile" className="subheader-search">
                  <Form.Control
                    type="search"
                    placeholder="search here"
                    onChange={(e) => setSearchQuiz(e.target.value)}
                    value={searchQuiz}
                  />
                  <FontAwesomeIcon
                    icon={faSearch}
                    className="search-icon"
                    onClick={handleSearch}
                  />
                </Form.Group>
                <button
                  onClick={() => navigate("/add-quiz")}
                  className={`${permit ? "" : "disabledbutton"} add-btn`}
                >
                  <FontAwesomeIcon icon={faPlus} /> Add New Quiz
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="table-main fixTableHead">
        {!isLoading ? (
          quizLists.length > 0 ? (
            <table className="table nowrap table-bordered table-default-dark">
              <thead>
                <tr className="table-heading">
                  <th>S.No</th>
                  <th>Quiz Name</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>No. of Questions</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {quizLists.map((quiz, index) => (
                  <tr key={quiz.quiz_id}>
                    <td>{index + 1}</td>
                    <td>{quiz.quiz_name}</td>
                    <td>{quiz.category_name}</td>
                    <td>{quiz.sub_category_name}</td>
                    <td>{quiz.no_of_questions}</td>
                    <td>{moment(quiz.created_at).format("DD/MM/YYYY")}</td>
                    <td>
                      <div
                        className={`status-toggle d-inline-block ${
                          quiz.status === "1" ? "active" : "inactive"
                        }`}
                        onClick={() =>
                          generateConfirm(
                            `Are you sure you want to make this quiz ${
                              quiz.status === "1" ? "Inactive" : "Active"
                            }?`,
                            `Press Yes if you want to ${
                              quiz.status === "1" ? "deactivate" : "activate"
                            } this quiz.`,
                            "quiz-status-toggle",
                            () => handleToggleStatus(quiz.quiz_id, quiz.status)
                          )
                        }
                      >
                        <div className="toggle-switch">
                          <div className="toggle-knob"></div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <Button
                        className="edit-btn me-1"
                        onClick={() => navigate(`/edit-quiz/${quiz.quiz_id}`)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </Button>

                      <Button
                        className="view-btn me-1"
                        onClick={() => navigate(`/view-quiz/${quiz.quiz_id}`)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </Button>

                      <Button className="delete-btn me-1">
                        <FontAwesomeIcon
                          icon={faTrash}
                          onClick={() =>
                            generateConfirm(
                              "Are you sure you want to Delete Quiz?",
                              "Press Yes if you want to delete",
                              "quiz-delete",
                              () => handleDeleteQuiz(quiz.quiz_id)
                            )
                          }
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <h1 className="no-data">No Record Found</h1>
          )
        ) : (
          <h1 className="no-data">Loading...</h1>
        )}
      </div>

      {totalCount > payload.limit && (
        <ReactPaginate
          previousLabel={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
          nextLabel={<FontAwesomeIcon icon={faAngleDoubleRight} />}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={"pagination custom-pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
  );
};

export default QuizList;
